module.exports = __webpack_public_path__ + "static/img/three.8bb3adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/12/three.png
// module id = wFYC
// module chunks = 1